import { render, staticRenderFns } from "./CompareProjectActions.vue?vue&type=template&id=2f94e1c5&scoped=true&"
import script from "./CompareProjectActions.vue?vue&type=script&lang=js&"
export * from "./CompareProjectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94e1c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
